import CircularProgress from '@mui/material/CircularProgress';

export { CircularProgress };
export default CircularProgress;
